import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';

export default class UpdateChannelColor {
  constructor(context) {
    this.context = context;
  }

  run({ channel, color }) {
    const preferences = this.context.stores.agentPreferences.get();
    preferences.setChannelColor(channel, color);
    setAgentPreferences(this.context, preferences);
  }
}
